import {useSnapshot} from "valtio";
import {state} from "./state";
import { Bars } from 'react-loading-icons'

const LoadingScreen = () => {
    const {loadingProgress} = useSnapshot(state);
    return(
      <div className="loading-screen">
          <Bars/>
          Loading, please wait
      </div>
    )
  }

  export default LoadingScreen;